import { render, staticRenderFns } from "./BestSeller.vue?vue&type=template&id=b543bfc0&scoped=true&"
import script from "./BestSeller.vue?vue&type=script&lang=js&"
export * from "./BestSeller.vue?vue&type=script&lang=js&"
import style0 from "./BestSeller.vue?vue&type=style&index=0&id=b543bfc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b543bfc0",
  null
  
)

export default component.exports